import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import {
  Card,
  Box as DarkBox,
  DarkProvider,
  SecurityDeviceIcon,
  Slider,
} from '@hivewatch/dark'

import { darkDeviceIconSizeSliderStyles } from './DarkDeviceIconSizeSlider.styles'

/** Leading icon in the panel header, sized to sit level with the label text. */
const HEADER_ICON_SIZE = 18

interface DarkDeviceIconSizeSliderIProps {
  min: number
  max: number
  value: number
  onChange: (value: number) => void
}

/**
 * Dark twin of DeviceIconSizeSlider. Wraps itself in DarkProvider because it
 * mounts on the chart rather than inside a panel, so there is no dark root
 * above it — the same shape DarkFloorPlanHeader uses.
 */
export const DarkDeviceIconSizeSlider = ({
  min,
  max,
  value,
  onChange,
}: DarkDeviceIconSizeSliderIProps) => {
  const colorScheme = useLightMode()
  const { t } = useTranslation()
  const s = darkDeviceIconSizeSliderStyles(colorScheme)

  return (
    <DarkProvider colorScheme={colorScheme}>
      <Card colorScheme={colorScheme} {...s.card}>
        <DarkBox {...s.header}>
          <SecurityDeviceIcon size={HEADER_ICON_SIZE} />
          <DarkBox {...s.label}>{t('floors:device_icon_size_label')}</DarkBox>
        </DarkBox>
        <Slider
          aria-label={t('floors:device_icon_size_label')}
          colorScheme={colorScheme}
          data-testid='FloorPlan:DeviceIconSize'
          max={max}
          min={min}
          onChange={onChange}
          step={0.05}
          value={value}
        />
      </Card>
    </DarkProvider>
  )
}
